import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend) // Loads translations from the backend (e.g., public/locales)
  .use(LanguageDetector) // Detects user's language
  .use(initReactI18next) // Passes the i18n instance to react-i18next
  .init({
    fallbackLng: ["th", "en"], // Fallback language if translation is missing
    debug: false, // Enable debug mode for development
    interpolation: {
      escapeValue: false, // React already escapes values by default
    },
    detection: {
      order: ["localStorage", "cookie", "navigator"], // detection order
      caches: ["localStorage", "cookie"], // where to store
    },
    backend: {
      loadPath: "/locales/{{lng}}.json", // Path to your translation files
    },
  });

export default i18n;
